

/// <reference path="AccountingEntry.ts" />

// Generated class PaymentInstallmentAccountingEntry_ManagedObject

class PaymentInstallmentAccountingEntry_ManagedObject extends AccountingEntry
{
    // Relationship: installment
    set installment(value:PaymentInstallment) {
        this.setValueForKey(value, 'installment');
    }
    get installment():PaymentInstallment {
        return this.valueForKey('installment') as PaymentInstallment;
    }
}
